module.exports = __webpack_public_path__ + "img/turn_icon_2.3d97ff9a.png";